import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { VehicleCastOffFullDossierRequest, VehicleFullDossierRequest } from "@app-model/dossier";
import { environment } from "@env/environment";

@Injectable({
  providedIn: "root",
})
export class DossierService {
  constructor(private http: HttpClient) {}

  getFullDossier(vehicleId, isRepurchase?: boolean): Observable<VehicleFullDossierRequest> {
    const queryParams: any = {};
    if (isRepurchase) {
      queryParams.isRepurchase = isRepurchase;
    }

    return this.http.get(
      `${environment.api}/evaluation/pricing/loadFullDossier/${vehicleId}`, {
        params: queryParams,
      }
    ) as Observable<VehicleFullDossierRequest>;
  }

  getFullDossierSell(vehicleId, isRepurchase?: boolean, isMyVehicle?: boolean): Observable<VehicleCastOffFullDossierRequest> {
    const queryParams: any = {};
    if (isRepurchase) {
      queryParams.isRepurchase = isRepurchase;
    }
    if (isMyVehicle) {
      queryParams.myVehicle = isMyVehicle;
    }

    return this.http.get(
      `${environment.api}/open/loadFullDossier/${vehicleId}`, {
        params: queryParams,
      }
    ) as Observable<VehicleCastOffFullDossierRequest>;
  }
}

export class DossierEmitHelper {
  callback: any;
  isRepurchase : boolean
}
